<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" text="Chi tiết phiếu xét nghiệm" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="detailsTest"/>
            </vx-tooltip>
        </div>

        <vs-popup class="holamundo" title="Kết quả xét nghiệm" :active.sync="popupDetailsTest" v-if="popupDetailsTest" id="popup-details-test">
            <vs-collapse type="margin">
                <vs-collapse-item v-for="(test, index) in params.data.beautyExaminationTestDetails" :key="index">
                    <div slot="header">
                        {{ test.beautyServicePackage.code + ' - ' + test.beautyServicePackage.name }}
                    </div>
                    <vs-table stripe hoverFlat :data="test.beautyExaminationTestDetailIndices" v-if="test.beautyExaminationTestDetailIndices.length > 0">
                        <template slot="thead">
                            <vs-th>
                                STT
                            </vs-th>
                            <vs-th>
                                Tên
                            </vs-th>
                            <vs-th>
                                Khoảng tham chiếu
                            </vs-th>
                            <vs-th>
                                Kết quả
                            </vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>
                                    {{ indextr + 1 }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.examinationTestNameß }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.normalValue }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.result }}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                    <div v-else class="text-center">
                        <span>Không có dữ liệu</span>
                    </div>
                </vs-collapse-item>
            </vs-collapse>
        </vs-popup>
    </div>
</template>

<script>
export default {
    name: "CellRendererActionsTestResults",
    data() {
        return {
            popupDetailsTest: false,
        }
    },

    created() {
    },

    methods: {
        detailsTest() {
            this.popupDetailsTest = true;
        },
    }
}
</script>

<style lang="scss">
#popup-details-test {
    z-index: 55000 !important;
}
</style>
